import styled from "styled-components";
import { Text } from "../styledConstants";

export const Wrapper = styled.div`
.item{
  display: flex;
    align-items: center;
    gap: 14px;
    /* margin: auto; */
    padding: 7px 10px 5px 20px;

}
.controle{
  box-shadow: inset 0px 1px 0px #ffffff61, 0px 1px 3px #00000042;
    border-radius: 5px;
}
  .logo {
    margin-bottom: 7px;
    margin-left: 20px;
    display: inline-block;
    vertical-align: top;
  }
  
  .user-logout-box{
    position: absolute;
    top: 100%;
    display: none;
    width: 100%;
  }
  .nav-v2-toggle {
    margin: 0 20px 16px;
  }
  .user-logout{
    z-index: 2;
    position: relative;   
    border: none;
     width: 100%;
    left: 0;
   right: 0;
   background-color: #fff;
   padding: 4px 0;
   border-radius: 4px;
   box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
   &>p{
    background-color: none;
    padding: 8px 16px;
    text-align: left;
    cursor: pointer;
    transition: all .3s;
    &:hover{
      background-color: #FFF3F4;
      //color: #fff;
    }
   }
  
  }
  .user-info {
   position: relative;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 54px;
    .item-select .select__control{
      background-color: #FFF3F4;
      border: 1px solid #FBB2B8;
      border-radius: 4px;
    }
  &:hover{
    .user-logout-box{
      display: block;

    }
    
  }
  
  }
`;

export const Nav = styled.nav`
  overflow-anchor: none;
  .navlist {
    overflow-anchor: none;
    > li {
      position: relative;
      > .nav-link {
        padding-left: 5px;
        padding-right: 0px;
        margin-left: 20px;
        margin-right: 20px;
        border: 1px solid transparent;
        transition: background color .3s;
          &.active {
            background: transparent linear-gradient(87deg, #ED141F 0%, #FEA13B 100%) 0% 0% no-repeat padding-box;
            box-shadow: inset 0px 1px 0px #ffffff61, 0px 1px 3px #00000042;
            border: 1px solid #ED141F;
            border-radius: 5px;
            .label{
              color: #fff;
            }
          }
          &:hover{
            border: 1px solid #ED141F;
            border-radius: 5px;
          }
        
      }
      &.active {
        .nav-box {
          background: transparent linear-gradient(87deg, #ED141F 0%, #FEA13B 100%) 0% 0% no-repeat padding-box;
          box-shadow: inset 0px 1px 0px #ffffff61, 0px 1px 3px #00000042;
          border-radius: 5px;
        }
        svg .cls-2 {
          fill: #015ba4;
        }
      }
    }
  }
  .sub-navlist {
    position: absolute;
    background: #fff;
    left: calc(100% + 8px);
    min-width: 250px;
    top: 0;
    border-radius: 0 10px 10px 0;
    box-shadow: 0px 1px 3px #ccc;
    max-height: min(70vh, 560px);
    padding: 20px 0;
    overflow-y: auto;
    overflow-x: hidden;
    li {
      padding: 0 30px;
      position: relative;
      
      &:last-child {
        .nav-link {
          border-bottom: none;
        }
      }
    }
    > li > .nav-link {
      padding-left: 30px;
      padding-right: 20px;
      border-bottom: 1px solid #ccc;
      &:before {
        content: "";
        position: absolute;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #DFDFDF;
        top: 16px;
        left: 40px;
      }
      &.active {
        &:before {   
          background: #ED141F;
        }
        > div {
          color: #ED141F;
        }
      }
    }
  }
  .nav-link {
    gap: 10px;
    min-height: 37px;
    padding-right: 12px;
    cursor: pointer;
    align-items: center;
  }
  .sub-navlist .nav-link {
    height: auto;
    min-height: 37px;
    white-space: normal;
    line-height: 1.35;
    padding-top: 10px;
    padding-bottom: 10px;
    word-break: break-word;
    align-items: flex-start;
  }
`;

export const NavIcon = styled.div`
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
